(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        return $resource('api/account/change-password', {}, {});
    }
})();
